import { createFileRoute, useParams } from "@tanstack/react-router";

import { ComposerPage } from "@/features/TextComposerV2/ComposerPage";

export const Route = createFileRoute("/_auth/compose-text/$siteId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = useParams({ from: "/_auth/compose-text/$siteId" });

  return <ComposerPage siteId={siteId} />;
}
